import React from 'react'
import { Builder } from '@builder.io/react'

export const ReadingMaterials = ({ copy }: { copy: string }): JSX.Element => {

  return (
    <div
      className="sm:px-[50px] sm:pb-4 lg:px-[78px] lg:pb-[30px] [&>ul]:list-disc [&>ul]:list-inside [&>ul]:p-0 [&>ol]:p-[inherit] [&>ol]:list-decimal [&_a]:a mt-4 [&_li]:pl-[20px] text-sm md:text-base"
      dangerouslySetInnerHTML={{
        __html: copy
      }}
    />
  )
}

Builder.registerComponent( ReadingMaterials, {
  name: `ReadingMaterialsCopy`,
  inputs: [
    {
      name: `copy`,
      type: `richText`,
      required: true
    }
  ]
})

export default ReadingMaterials